import React from 'react';

const TermAndConditions = ({
	changeTerm,
	handleBlur,
	setFieldValue,
	signatureChosen,
	cmDrConsulta
}) => {
	const planType = sessionStorage.getItem('planType');
	const object = signatureChosen || cmDrConsulta;
	const planId = object?.planId || null;

	const getTermsUrl = (planType, planId) => {
		const urls = {
			familia: {
				shared: {
					drConsulta:
						'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-Dr.-Consulta-vsite.pdf',
					nacionalValeSaude:
						'https://yalo.com.br/wp-content/uploads/Contrato-Yalo-Cartao-drconsulta-nacional-valesaude-vsite.pdf',
					odonto:
						'https://yalo.com.br/wp-content/uploads/03.Termos-e-condi%C3%A7%C3%B5es-cart%C3%A3o-odonto.pdf',
					drcOdonto:
						'https://yalo.com.br/wp-content/uploads/01.Termos-e-condi%C3%A7%C3%B5es-cart%C3%A3o-DRC-Odonto.pdf',
					drc:
						'https://yalo.com.br/wp-content/uploads/02.Termo-e-condi%C3%A7%C3%B5es-cart%C3%A3o-DRC.pdf',
					materna:
						'https://yalo.com.br/wp-content/uploads/Termos_e_Condicoes_DRC_Programa_Materna.pdf',
					default:
						'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-Familia-vsite.pdf'
				},
				groups: {
					drConsulta: ['115', '116', '117', '130'],
					nacionalValeSaude: ['119', '120'],
					odonto: ['121', '122', '123'],
					drcOdonto: ['124', '125', '126', '127', '128', '129', '131'],
					drc: ['132', '133', '134', '135', '136', '137'],
					materna: ['138']
				}
			},
			fidelidade:
				'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-Fidelidade-Virtual-Individual-PF-vsite.pdf',
			saude:
				'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-Saude-Individual-PF-vsite.pdf',
			vida:
				'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-Vida-Virtual-Individual-PF-vsite.pdf',
			emed:
				'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-eMed-Virtual-Individual-PF-vsite.pdf',
			individual:
				'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-Individual-PF-vSite.pdf',
			telemedicina:
				'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-Telemedicina-Virtual-Individual-PF-vsite.pdf',
			mais:
				'https://yalo.com.br/wp-content/uploads/Contrato-Clube-YALO-Mais-Individual-PF-vSite.pdf'
		};

		if (planType === 'familia') {
			const { shared, groups } = urls.familia;
			for (const [key, ids] of Object.entries(groups)) {
				if (ids.includes(planId)) return shared[key] || shared.default;
			}
			return shared.default;
		}

		return urls[planType] || '';
	};

	const termsUrl = getTermsUrl(planType, planId);
	const privacyPolicyUrl =
		'https://yalo.com.br/wp-content/uploads/Política-de-Privacidade-e-Segurança-Yalo.pdf';

	return (
		<div>
			<label className='switch'>
				<input
					type='checkbox'
					id='termos1'
					name='termos1'
					onChange={e => changeTerm(e, setFieldValue)}
					onBlur={handleBlur}
					required
				/>
				<span className='slider round'></span>
				<span>
					Declaro que li e estou de acordo com os{' '}
					<a href={termsUrl} rel='noopener noreferrer' target='_blank'>
						Termos e Condições do Produto
					</a>{' '}
					e a{' '}
					<a href={privacyPolicyUrl} rel='noopener noreferrer' target='_blank'>
						Políticas de Privacidade
					</a>
					.
				</span>
			</label>
		</div>
	);
};

export default TermAndConditions;
